// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"794c4adf","388":"e00d54b3","722":"f0b9a092","798":"e1d000f8","878":"c9dee5dd","933":"16b9146c"}[chunkId] + ".chunk.js";
};